import SchemaPermissions from "@/components/SchemaPermissions"
import React from "react"

const SchemaPermissionsView = () => {
  return <SchemaPermissions />
}

export default SchemaPermissionsView
